module.exports = __webpack_public_path__ + "img/banner-accident.77ce63df.jpg";